"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseILeadFeedbackGoogleSettings = void 0;
const ilead_feedback_google_conversion_action_ids_1 = require("./ilead-feedback-google-conversion-action-ids");
const ilead_feedback_google_settings_consent_1 = require("./ilead-feedback-google-settings-consent");
function parseILeadFeedbackGoogleSettings(data) {
    if (data.conversionActionIds !== null && typeof data.conversionActionIds === 'object')
        data.conversionActionIds = (0, ilead_feedback_google_conversion_action_ids_1.parseILeadFeedbackGoogleConversionActionIds)(data.conversionActionIds);
    if (data.consent !== null && typeof data.consent === 'object')
        data.consent = (0, ilead_feedback_google_settings_consent_1.parseILeadFeedbackGoogleSettingsConsent)(data.consent);
    return data;
}
exports.parseILeadFeedbackGoogleSettings = parseILeadFeedbackGoogleSettings;
